import styled from "styled-components";

export const Pill = styled.div<{ active?: boolean }>`
  display: flex;
  padding: 4px 12px;
  border: 1px solid #e1e5e9;
  color: #010024;
  border-radius: 100px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: bold;
  align-items: center;

  ${({ active }) =>
    active &&
    `
    background-color: #0d6efd;
    color: white;
    border-color: #0d6efd;
  `}
`;

export const Pills = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 4px;
  padding: 10px 0;
`;
